// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5283":"4e644f54","7386":"de03b436"}[chunkId] + ".chunk.css";
};